import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export function VolunteerContactDialog({ volunteer, onOpenChange, onSaved }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (volunteer) setForm({ name: volunteer.name || "", email: volunteer.email || "", phone: volunteer.phone || "" });
  }, [volunteer]);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/volunteers/${volunteer.id}`, form);
      toast.success("Anagrafica aggiornata");
      onSaved(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!volunteer} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Anagrafica volontario</DialogTitle>
          <DialogDescription>Completa o correggi i dati di contatto. Il nuovo nome compare anche nei servizi.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>Nome e cognome</Label>
            <Input data-testid="contact-name" value={form.name} onChange={(e) => set("name", e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label>Email {volunteer?.external && <span className="text-muted-foreground font-normal">(facoltativa)</span>}</Label>
            <Input type="email" data-testid="contact-email" value={form.email} onChange={(e) => set("email", e.target.value)} />
            {!volunteer?.external && <p className="text-[11px] text-muted-foreground">È anche l'email con cui il volontario accede all'app.</p>}
          </div>
          <div className="space-y-1.5">
            <Label>Telefono</Label>
            <Input type="tel" data-testid="contact-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} placeholder="333 1234567" />
          </div>
        </div>
        <DialogFooter>
          <Button data-testid="contact-save" onClick={save} disabled={saving || !form.name.trim()} className="rounded-full font-semibold">
            {saving ? "Salvataggio…" : "Salva"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
